import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, fromEvent, merge, of, timer } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ZeroService } from './zero/zero.service';
import { SessionService } from 'src/app/_services/session.service';
import { CookieService } from 'ngx-cookie-service';
import { Globals } from 'src/app/_services/zero/globals';


@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private userActivity: Subject<any> = new Subject();
  private sessionTimeout$ = timer(15 * 60 * 1000); // 15 minutos
  // private sessionTimeout$ = timer(60 * 1000);
 // private sessionTimeout$ = timer(5 * 60 * 1000);
  private resetTimeout$ = new Subject<void>();

  constructor(
    private router: Router,
    private session: SessionService,
    public globals: Globals,
    private cookieService: CookieService,
    private zero: ZeroService
  ) {
    this.initUserActivityListener();
    this.startSessionTimeout();
  }

  // Escucha la actividad del usuario (clics, teclado, mouse)
  private initUserActivityListener() {
    const activityEvents$: Observable<any> = merge(
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'click'),
      fromEvent(window, 'keypress')
    );

    activityEvents$.subscribe(() => this.resetTimeout());
  }

  // Comienza a contar el tiempo para cerrar sesión
  private startSessionTimeout() {
    this.resetTimeout$.pipe(
      switchMap(() => this.sessionTimeout$),
      takeUntil(this.userActivity)
    ).subscribe(() => this.logout());
  }

  // Restablece el temporizador cada vez que hay actividad
  private resetTimeout() {
   
    this.resetTimeout$.next();
  }

  // Cierra la sesión
  private logout() {
    // Aquí puedes limpiar el estado de autenticación, cerrar sesión y redirigir al usuario
   // alert('Sesión cerrada por inactividad.'+environment.uris.comunes.logout);
   // this.appComponent.logout();
   // this.router.navigate([environment.uris.comunes.logout]); // Redirige al login

   console.log("Inicia logout");
   var scope = this;
   this.zero.request({
    uri: environment.uris.comunes.borrarPerfilamiento,
    method: "DELETE",
    ok: response => {
      if (response.response) {
        console.log("Se borro redis.");
        console.log("Se borrara session storage.");
        scope.session.deleteFromSession("perfiles");
        console.log("Se borrara cookie.");
        scope.cookieService.delete(environment.app);
        scope.cookieService.deleteAll();
        console.log("Se borrara local storage.");
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentRol');
        console.log("Se dara logout en Forgerock.");
        scope.globals = new Globals();         
        //let news = window.open("", "cerrarSesion", "width=600, height=200");
        //let tmot = setTimeout(() => { window.open(environment.uris.comunes.logout, "cerrarSesion") }, 0);  
        //tmot = setTimeout(() => { news.close(); window.location.reload(); console.log("ventana abierta tiempo 1500s");}, 1500);

        let news: Window | null = window.open("", "cerrarSesion", "width=600, height=200");
        // validar si la venta emergente no esta bloqueada para abrir
        if (news) {
          console.log("Ventana emergente abierta.");
          setTimeout(() => {
            news!.location.href = environment.uris.comunes.logout;
          }, 0);

          setTimeout(() => {
            if (news && !news.closed) {
              console.log("Cerrando ventana.");
              news.close();
            } else {
              console.warn("La ventana ya estaba cerrada.");
            }
            window.location.reload();
          }, 1500);
        } else {
          console.warn("No se pudo abrir la ventana emergente.");
        }
       }
     }
   });
   console.log("Termina logout");


    console.log('Sesión cerrada por inactividad.');
  }
}
